import Env from 'Env';

const XLSX = 'XLSX';
const CSV = 'CSV';

type ReportTypeOption = {
  reportTypeId: number;
  filters: {
    showFilters: boolean;
    showProcessedDateSection?: boolean;
    minFromDate?: string;
    showCardDriverDetailsSection?: boolean;
    showCostCentre?: boolean;
    showDomesticNumber?: boolean;
    showCardNumber?: boolean;
    showRegistration?: boolean;
    showOtherFiltersSection?: boolean;
    showLocation?: boolean;
    showCreditsOnly?: boolean;
    showFuelPay?: boolean;
    showProductsSection?: boolean;
    showCardRenewalPeriod?: boolean;
    showMinNumFills?: boolean;
    showVolumeLitres?: boolean;
    showMinNumCarWash?: boolean;
    showTransactionMoreThan?: boolean;
    showTransaction10PM5AM?: boolean;
    showMonthToDateCardLimitSection?: boolean;
    showMonthToDateCardLimit?: boolean;
    showActiveVehicles?: boolean;
  };
  scheduleOptions?: {
    removeFytdUntilJuly?: boolean;
  };
  showReportingPeriod: boolean;
  outputFormats: ('XLSX' | 'CSV')[];
};

const reportTypeOptionsConfig: ReportTypeOption[] = [
  {
    // Account Fuel Spend Summary Report
    reportTypeId: 1,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      minFromDate: '2023-12-01',
      showCardDriverDetailsSection: true,
      showCostCentre: true,
      showDomesticNumber: true,
    },
    scheduleOptions: {
      removeFytdUntilJuly: true,
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Account Spend Summary by Location Report
    reportTypeId: 2,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      minFromDate: '2023-12-01',
    },
    scheduleOptions: {
      removeFytdUntilJuly: true,
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Account Transaction Detail Report
    reportTypeId: 3,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      showCardDriverDetailsSection: true,
      showCardNumber: true,
      showCostCentre: true,
      showDomesticNumber: true,
      showRegistration: true,
      showOtherFiltersSection: true,
      showLocation: false,
      showCreditsOnly: true,
      showFuelPay: true,
      showProductsSection: true,
      minFromDate: '2023-12-01',
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Account Transaction Summary (GST) Report
    reportTypeId: 4,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      minFromDate: '2023-12-01',
    },
    scheduleOptions: {
      removeFytdUntilJuly: true,
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Account Transaction Summary Report
    reportTypeId: 5,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      minFromDate: '2023-12-01',
      showCardDriverDetailsSection: true,
      showDomesticNumber: true,
      showRegistration: true,
    },
    scheduleOptions: {
      removeFytdUntilJuly: true,
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Card Details Report-Structure
    reportTypeId: 6,
    filters: {
      showFilters: true,
      showCardDriverDetailsSection: true,
      showCostCentre: true,
      showDomesticNumber: true,
    },
    showReportingPeriod: false,
    outputFormats: [XLSX],
  },
  {
    // Card Details Report
    reportTypeId: 7,
    filters: {
      showFilters: true,
      showCardDriverDetailsSection: true,
      showCostCentre: true,
      showDomesticNumber: true,
    },
    showReportingPeriod: false,
    outputFormats: [XLSX],
  },
  {
    // Card Summary Report
    reportTypeId: 8,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      showCardDriverDetailsSection: true,
      showCardNumber: true,
      minFromDate: '2023-12-01',
    },
    showReportingPeriod: false,
    outputFormats: [XLSX],
  },
  {
    // Card Expiry Report
    reportTypeId: 9,
    filters: {
      showFilters: true,
      showCardDriverDetailsSection: true,
      showCardRenewalPeriod: true,
    },
    showReportingPeriod: false,
    outputFormats: [XLSX],
  },
  {
    // FuelPay - Card Details Report
    reportTypeId: 10,
    filters: {
      showFilters: true,
      showCardDriverDetailsSection: true,
      showCardNumber: true,
      showCostCentre: true,
      showDomesticNumber: true,
      showOtherFiltersSection: true,
      showFuelPay: true,
    },
    showReportingPeriod: false,
    outputFormats: [XLSX],
  },
  {
    // Exception Report
    reportTypeId: 11,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      showCardDriverDetailsSection: true,
      showCardNumber: true,
      showCostCentre: true,
      showRegistration: true,
      showOtherFiltersSection: true,
      showMinNumFills: true,
      showVolumeLitres: true,
      showMinNumCarWash: true,
      showTransactionMoreThan: true,
      minFromDate: '2023-12-01',
      showTransaction10PM5AM: true,
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Service & Repairs Exceptions Report
    reportTypeId: 12,
    filters: {
      showFilters: false,
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Services & Repairs Cost Details Report
    reportTypeId: 13,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      showCardDriverDetailsSection: true,
      showRegistration: true,
      showOtherFiltersSection: true,
      showActiveVehicles: true,
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Services & Repairs Details Report
    reportTypeId: 14,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      showCardDriverDetailsSection: true,
      showRegistration: true,
      showOtherFiltersSection: true,
      showActiveVehicles: true,
      minFromDate: '2023-12-01',
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Services & Repairs Maintenance Data Load
    reportTypeId: 15,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      minFromDate: '2023-12-01',
    },
    showReportingPeriod: true,
    outputFormats: [CSV],
  },
  {
    // Services & Repairs Maintenance Report
    reportTypeId: 16,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      minFromDate: '2023-12-01',
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Services & Repairs Vehicle Register
    reportTypeId: 17,
    filters: {
      showFilters: false,
    },
    showReportingPeriod: false,
    outputFormats: [XLSX],
  },
  {
    // Purchases for BAS
    reportTypeId: 18,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      minFromDate: '2023-01-01',
    },
    scheduleOptions: {
      removeFytdUntilJuly: true,
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Greenhouse Gas Emissions
    reportTypeId: 19,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      showCardDriverDetailsSection: true,
      minFromDate: '2023-12-01',
      showCardNumber: true,
      showDomesticNumber: true,
      showRegistration: true,
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  {
    // Cancelled Card Report
    reportTypeId: 22,
    filters: {
      showFilters: true,
      showCardDriverDetailsSection: true,
      showCostCentre: true,
      showDomesticNumber: true,
    },
    showReportingPeriod: false,
    outputFormats: [XLSX],
  },
  {
    // Cards Close to Monthly Purchase Limit Report
    reportTypeId: 23,
    filters: {
      showFilters: true,
      showMonthToDateCardLimitSection: true,
      showMonthToDateCardLimit: true,
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
  // Feature flag: EV Way4 reports — always included in base array; filtered out
  // at call time by getReportTypeOptionsConfig() when VITE_EV_WAY4 is disabled.
  {
    // EV Charging Detailed Report
    reportTypeId: 24,
    filters: {
      showFilters: true,
      showProcessedDateSection: true,
      minFromDate: '2023-12-01',
      showCardDriverDetailsSection: true,
      showCostCentre: true,
      showDomesticNumber: true,
      showCardNumber: true,
      showRegistration: true,
    },
    showReportingPeriod: true,
    outputFormats: [XLSX],
  },
];

// Evaluated lazily so the feature flag is read at call time, not frozen at module-load time.
// Feature flag: filters out EV Charging Detailed Report (reportTypeId 24) when VITE_EV_WAY4 is disabled.
export const getReportTypeOptionsConfig = (): ReportTypeOption[] =>
  reportTypeOptionsConfig.filter((r) => r.reportTypeId !== 24 || Env.getIsEvWay4Enabled());

export default getReportTypeOptionsConfig;
